/**
 * @method getOverallProgress
 * @param {Set} downloadedAbsolutePaths - list of all downloaded paths for the book
 * @param {Set} absolutePaths - set of all paths for book content for an offline session
 * @return {Object} object with information about the overall progress of an offline download
 */
const getOverallProgress = (
  downloadedAbsolutePaths = new Set(),
  absolutePaths = new Set(),
  allDocumentsCompletedDownloading = true,
) => {
  let percentage = absolutePaths.size
    ? downloadedAbsolutePaths.size / absolutePaths.size
    : 1;

  // If all documents are not complete, prevent the progress from reaching 100%.
  if (!allDocumentsCompletedDownloading) {
    percentage = Math.min(percentage, 0.99);
  }

  return {
    absolutePaths,
    downloadedAbsolutePaths,
    isComplete:
      downloadedAbsolutePaths.size === absolutePaths.size &&
      allDocumentsCompletedDownloading,
    percentage,
    percentageDisplay: Math.round(percentage * 10000) / 100,
  };
};

export default getOverallProgress;
